// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/shortcuts/format.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/shortcuts/src/format.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo tendly-app
//     node fleet/fleet.ts check --repo tendly-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Display formatting for key bindings.
 *
 * Splits "Mod+Shift+K" or "g i" into platform-aware tokens that <kbd> can render.
 * Sequence steps (chords) are separated by a " then " marker; UI may render
 * each step in its own group.
 */

import type { PlatformAdapter } from "./types";

interface FormattedStep {
  keys: string[];
}

interface FormattedBinding {
  steps: FormattedStep[];
}

export function formatBinding(spec: string, platform: PlatformAdapter): FormattedBinding {
  const steps = spec.trim().split(/\s+/u).filter(Boolean);
  return {
    steps: steps.map((step) => ({
      keys: step.split("+").map((token) => platform.formatKey(token)),
    })),
  };
}

/** Flattens the formatted binding to a single array of keys (separator inserted by UI). */
export function flatFormatBinding(spec: string, platform: PlatformAdapter): string[] {
  return formatBinding(spec, platform).steps.flatMap((s) => s.keys);
}
